module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-7.64194315.png";